// Shared OVH image helpers for Admin canvas previews.
const OVH_BUCKET = process.env.REACT_APP_OVH_BUCKET || 'xfive';
const OVH_ENDPOINT = process.env.REACT_APP_OVH_ENDPOINT || 's3.eu-south-mil.io.cloud.ovh.net';
const OVH_HOST = `${OVH_BUCKET}.${OVH_ENDPOINT}`;

export const isOVHUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  try {
    return new URL(url).hostname === OVH_HOST;
  } catch (_) {
    return false;
  }
};

// The OVH bucket serves its own Access-Control-Allow-Origin: * on GET/HEAD,
// so images can be loaded directly — no need to round-trip through the backend.
export const toProxiedUrl = (url) => url;

export const getImageUrl = (img) => {
  if (!img) return null;
  if (typeof img === 'string') return toProxiedUrl(img);
  if (img.url && typeof img.url === 'object' && img.url.url) return toProxiedUrl(img.url.url);
  if (img.url && typeof img.url === 'string') return toProxiedUrl(img.url);
  if (img.original && typeof img.original === 'string') return toProxiedUrl(img.original);
  if (img.medium && typeof img.medium === 'string') return toProxiedUrl(img.medium);
  if (img.thumbnail && typeof img.thumbnail === 'string') return toProxiedUrl(img.thumbnail);
  return null;
};

export const withCacheBust = (url) => {
  if (!url || typeof url !== 'string') return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}t=${Date.now()}`;
};
